var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1004 1020H20c-8.8 0-16-7.2-16-16V416c0-5.6 3.2-11.2 8.8-14.4 5.6-2.4 12-2.4 16.8 0.8L512 737.6l483.2-335.2c4.8-3.2 11.2-4 16.8-0.8 5.6 2.4 8.8 8 8.8 14.4v588c-0.8 8.8-8 16-16.8 16z m-968-32h952V446.4L520.8 770.4c-5.6 4-12.8 4-18.4 0L36 446.4v541.6z",
    fill: "#0E1856"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1004 1020c-4 0-8-1.6-11.2-4.8L647.2 668.8c-6.4-6.4-6.4-16 0-22.4 6.4-6.4 16-6.4 22.4 0l345.6 347.2c6.4 6.4 6.4 16 0 22.4-3.2 2.4-7.2 4-11.2 4zM20 1020c-4 0-8-1.6-11.2-4.8-6.4-6.4-6.4-16 0-22.4l345.6-347.2c6.4-6.4 16-6.4 22.4 0 6.4 6.4 6.4 16 0 22.4L31.2 1015.2c-3.2 3.2-7.2 4.8-11.2 4.8zM831.2 552c-2.4 0-4.8-0.8-7.2-1.6-5.6-2.4-8.8-8-8.8-14.4V296c0-5.6 3.2-11.2 8.8-14.4 5.6-2.4 12-2.4 16.8 0.8l172.8 120c4 3.2 7.2 8 7.2 12.8 0 5.6-2.4 10.4-7.2 12.8l-172.8 120c-3.2 3.2-6.4 4-9.6 4z m16-225.6v178.4L976 416l-128.8-89.6zM192.8 552c-3.2 0-6.4-0.8-8.8-3.2l-172.8-120c-4-3.2-7.2-8-7.2-12.8 0-5.6 2.4-10.4 7.2-12.8l172.8-120c4.8-3.2 11.2-4 16.8-0.8 5.6 2.4 8.8 8 8.8 14.4v240c0 5.6-3.2 11.2-8.8 14.4-3.2 0-5.6 0.8-8 0.8zM48 416l128.8 89.6V326.4L48 416z",
    fill: "#0E1856"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 773.6c-3.2 0-6.4-0.8-8.8-3.2L184 548.8c-4-3.2-7.2-8-7.2-12.8V20c0-8.8 7.2-16 16-16h638.4c8.8 0 16 7.2 16 16V536c0 5.6-2.4 10.4-7.2 12.8L520.8 770.4c-2.4 2.4-5.6 3.2-8.8 3.2zM208.8 528L512 737.6 815.2 528V36H208.8V528z",
    fill: "#0E1856"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M711.2 159.2H313.6c-4.8 0-8-3.2-8-8s3.2-8 8-8H712c4.8 0 8 3.2 8 8-0.8 4-4 8-8.8 8zM711.2 304H313.6c-4.8 0-8-3.2-8-8s3.2-8 8-8H712c4.8 0 8 3.2 8 8-0.8 4.8-4 8-8.8 8zM711.2 448.8H313.6c-4.8 0-8-3.2-8-8s3.2-8 8-8H712c4.8 0 8 3.2 8 8-0.8 4.8-4 8-8.8 8z",
    fill: "#0E1856"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email2.82de4c2307e0c8b9f1fae597dc122b58.svg";
export { ForwardRef as ReactComponent };